import { render, staticRenderFns } from "./padding-settings.vue?vue&type=template&id=4c8edb48&scoped=true&"
import script from "./padding-settings.vue?vue&type=script&lang=js&"
export * from "./padding-settings.vue?vue&type=script&lang=js&"
import style0 from "./padding-settings.vue?vue&type=style&index=0&id=4c8edb48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8edb48",
  null
  
)

export default component.exports